export class CampoSpecificoFascicoloDTO {
  nome: string;
  valore: any[];
  codice: string;
  tipoDato: string;
}
